// MyFlexWrapBox.tsx
import React from 'react';

interface MyFlexWrapBoxProps {
  children: React.ReactNode;
  className?: string;
  gap?: 'sm' | 'md' | 'lg' | 'xl';
  align?: 'start' | 'center' | 'end' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
}

const gapClasses = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
  xl: 'gap-6'
};

const alignClasses = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch'
};

const justifyClasses = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly'
};

export const MyFlexWrapBox = ({
  children,
  className = '',
  gap = 'md',
  align = 'center',
  justify = 'start'
}: MyFlexWrapBoxProps) => {
  return (
    <div className={`
      flex flex-wrap
      ${gapClasses[gap]}
      ${alignClasses[align]}
      ${justifyClasses[justify]}
      ${className}
    `}>
      {children}
    </div>
  );
};